<template>
    <cadastro-simples-list
        endpoint="cartorio"
        rota-base="/admin/cartorio"
        titulo="CARTÓRIOS"
        titulo-singular="Cartório"
        :colunas-extras='[
            { campo: "serventia", label: "Serventia", tipo: "string" }
        ]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
